export default __webpack_public_path__ + "static/media/ctci_icon_only.422df250.svg";